import { render } from "./EndUser.vue?vue&type=template&id=68b3716c&ts=true"
import script from "./EndUser.vue?vue&type=script&lang=ts"
export * from "./EndUser.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__